export const maskFormat = {
  bind(element, binding, vNode) {
    const applyMask = (value, mask) => {
      if (!mask || mask.length === 0) {
        return value
      }
      let formattedValue = ''
      let valueIndex = 0
      for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
        if (mask[i] === '#') {
          formattedValue += value[valueIndex]
          valueIndex++
        } else {
          formattedValue += mask[i]
        }
      }
      return formattedValue
    }
    const handleInput = (event) => {
      const originalValue = event.target.value
      const mask = binding.value
      const value = mask ? originalValue.replace(/\D/g, '') : originalValue
      const formattedValue = applyMask(value, mask)
      if (originalValue !== formattedValue) {
        event.target.value = formattedValue
        vNode.context.$nextTick(() => {
          element.dispatchEvent(new Event('input'))
        })
      }
    }
    element._handleInput = handleInput
    element.addEventListener('input', handleInput)
  },
  unbind(element) {
    element.removeEventListener('input', element._handleInput)
  }
}
